export default __webpack_public_path__ + "static/media/physics.d6835459.svg";